










































































































































import Vue from 'vue';

import { Repository } from '@/db/_repo';
const db = new Repository();

import { storage } from '@/db/storage';
import { functions }    from '@/db/firestore.ts';

import avatar       from '@/components/users/avatar.vue'; 
import subs         from '@/components/app/subscriptions.vue';
import signinbtn    from '@/components/btn-signin.vue';
import Modal        from "@/components/Modal.vue";

export default Vue.extend({
    data() {
        return {
            thisUser: { phoneNumber: '', phoneVerified: false},
            thisOUser: {},
            showVerifyPhone: false,
            textSending: false,
            verifyCode: '',
            correctCode: '',
        }
    },
    props: ['thisOrigUser'],
    components: {
        avatar,
        subs,
        'sign-in-btn': signinbtn,
        Modal,
    },
    computed: {
        userSince() {
            const ts = this.thisUser.createdAt;
            const date = db.toDate(ts);
            if (date) return date.toDateString();
            return null;
        },
        isDirty(): boolean {
            let isDirty = 
                this.thisUser.displayName   !== this.thisOUser.displayName || 
                this.thisUser.email         !== this.thisOUser.email || 
                this.thisUser.phoneNumber   !== this.thisOUser.phoneNumber;

            return isDirty;
        },
        photoMatch() {
            return this.currentUser.photoURL === this.thisUser.photoURL;
        },
        phoneMatch() {
            return this.thisUser.phoneNumber == this.thisOUser.phoneNumber;
        },
        phoneVerified() {
            return this.phoneMatch && this.thisUser.phoneVerified;
        }
    },
    methods: {
        saveProfile() {
            db.users.updateUserProfile(this.thisUser).then(() => {
                this.thisOUser = {...this.thisUser}
            });
        },
        clickFileBtn() {
            document.getElementById('btnFiles').click();
        },
        startVerify() {
            this.showVerifyPhone = true;
            this.sendVerifyText()
        },
        sendVerifyText() {
            this.textSending = true;
            const verifyPhoneNumber = functions.httpsCallable('verifyPhoneNumber');
            verifyPhoneNumber({ phN: this.thisUser.phoneNumber })
            .then((res) => {
                this.correctCode = res.data.code;
            })
            .catch(e => this.toastAndError(this, 'There was an error sending the text.  Please try again.', e))
            .finally(() => setTimeout(() => this.textSending = false , 500));
        },
        checkCode() {
            if (this.verifyCode === this.correctCode.toString()) {
                this.thisUser.phoneVerified = true;
                this.saveProfile();
            } else {
                this.$toast.open({
                    message: 'That code was incorrect.  Please try again.',
                    type: 'error',
                    duration: 3000,
                    position: 'top-right'
                });
            }

            setTimeout(() => this.showVerifyPhone = false, 1000);
            setTimeout(() => {
                this.$toast.open({
                    message: 'Phone verified. Thanks!',
                    type: 'success', duration: 3000, position: 'top-right' 
                });
            }, 1250);
        },
        uploadProfilePic(event) {
            const file = (<HTMLInputElement>document.getElementById('btnFiles')).files[0];
            if (file) {
                console.log("file", file.name);
                var filePath = `/quizme/profilePics/${this.currentUser.uid}/${file.name}`;
                storage.ref(filePath).put(file).then((snap) => {
                    snap.ref.getDownloadURL().then((url) => { 
                        this.thisUser.photoURL = url;
                        this.saveReload();
                    })
                })
                .catch((e) => this.toastAndError(this, 'There was an error processing the upload.  Try again.', e));
            } else {
                console.log("No file selected")
            }
        },
        removePic() {
            this.thisUser.photoURL = this.currentUser.photoURL;
            this.saveReload();
        },
        saveReload() {
            this.saveProfile();
            // #146 I know, I know...reloading in Vue.  There's a better way to do this but I spend *hours* and couldn't figure it out.  
            // This is good enough for MVP.  Something something Vuex having profile in State
            window.location.reload();
        }
    },
    created() {
        this.thisUser = {...this.thisOrigUser};
        this.thisOUser = {...this.thisOrigUser};
    }
})
